import { Icon, IconProps } from "@chakra-ui/react";

export const Monkey = (props: IconProps) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 216" fill="none" {...props}>
      <path fill="#343436" d="M8 200h8v4H8v-4ZM20 200h4v4h-4v-4ZM64 204H48v-4H36v4h-8v4h36v-4ZM72 200h-4v4h4v-4Z" />
      <path fill="#151515" d="M28 192h-4v4h4v-4ZM36 192h-4v4h4v-4ZM48 196h8v-4h4v8H48v-4Z" />
      <path fill="#CCC2B1" d="M28 200h-4v4h4v-4ZM52 200h-4v4h4v-4Z" />
      <path
        fill="#EBDFCC"
        d="M56 184h4v4h-4v-4ZM56 192h-4v4h4v-4ZM28 204v-4h8v4h-8ZM68 200v4H52v-4h16ZM32 184h-4v8h4v-8Z"
      />
      <path
        fill="#B98359"
        d="M44 48h-4v8h4v-8ZM20 56h8v4h-8v-4ZM16 72V60h4v12h-4ZM16 72v48h-4V72h4ZM24 72h4v4h-4v-4ZM24 76v4h-4v-4h4ZM60 72h4v40h-4V72Z"
      />
      <path fill="#2E1E06" d="M40 44h4v4h-4z" />
      <path fill="#64402E" d="M44 12h-4v4h4v4h4v4h4v4h4v-4h-4v-4h-4v-4h-4v-4ZM60 40h-4v4h-8v4h8v-4h4v-4Z" />
      <path fill="#C88D74" d="M52 32h-4v4h4v-4ZM56 40H44v4h12v-4Z" />
      <path fill="#000" d="M44 32h-4v4h4v-4ZM56 32h-4v4h4v-4Z" />
      <path fill="#AD7A65" d="M36 28h-8v8h4v-4h4v-4Z" />
      <path fill="#E1AA90" d="M52 24h-4v4h-4v12h16v-4H48v-4h8v-4h-4v-4ZM36 32h-4v4h4v-4Z" />
      <path fill="#C7967F" d="M44 24h-4v8h4v-8ZM44 36h-4v4h4v-4Z" />
      <path
        fill="#4A2F22"
        d="M36 12h4v4h-4v-4ZM44 20v-4h-4v4h-4v4h-4v4h4v8h-4v4h4v4h8v8h8v-4h-4v-4h-4v-4h-4V24h4v4h4v-8h-4Z"
      />
      <path fill="#CCD3E0" d="M40 52h-4v4h4v4h4v4h8v-4h4v-4h-4v4h-8v-4h-4v-4Z" />
      <path fill="#B0B0B0" d="M12 120h4v8h4v4h-8v-12ZM12 136h4v8h4v4h-8v-12ZM16 152h-4v12h4v-12Z" />
      <path fill="#D1D1D1" d="M20 116h-4v4h4v-4ZM20 132h-4v8h4v-8ZM16 148h4v8h-4v-8ZM20 160h-4v8h4v-8Z" />
      <path fill="#E6A46E" d="M44 52h8v8h-8v-8Z" />
      <path
        fill="#E6A46E"
        d="M44 64v-4h-4v-4h-4v12h16v-4h-8ZM60 56h4v4h4v60h-4v-4h-4v-4h4V72h-4V56ZM64 120v4h-4v-4h4ZM28 60h-8v12h-4v44h4v4h-4v4h4v-4h4v-4h-4V76h4v-4h4V60Z"
      />
      <path
        fill="#3D4543"
        fillRule="evenodd"
        d="M36 52h-4v56h28V56h-4v-4h-4v4h4v4h-4v8H36V52Zm0 28v4h20v-4H36Zm0 8h20v4H36v-4Zm0 8v4h20v-4H36Z"
        clipRule="evenodd"
      />
      <path fill="#343434" d="M32 52h-4v24h-4v36h36v-4H32V52Z" />
      <path fill="#343434" d="M56 96H36v4h20v-4ZM36 88h20v4H36v-4ZM56 80H36v4h20v-4Z" />
      <path fill="#415D66" d="M32 112h28v44h-8v-4h4v-28H36v32h-8v-4h4v-40ZM28 160h4v24h-4v-24ZM56 160h-4v24h4v-24Z" />
      <path fill="#223136" d="M24 112v76h4v-28h4v-4h-4v-4h4v-40h-8ZM48 124h8v28h-4v4h4v4h-4v28h-4v-64Z" />
      <path fill="#D92525" d="M36 188h-4v4h-4v4h-4v4h4v-4h4v-4h4v-4ZM52 188h-4v8h4v-8Z" />
      <path fill="#F52A2A" d="M56 184h-4v8h8v8h8v-4h-4v-4h-4v-4h-4v-4ZM28 196h8v4h-8v-4Z" />
      <g
        fill="#0A8F4F"
        style={{
          mixBlendMode: "color",
        }}
      >
        <path
          fillRule="evenodd"
          d="M44 12v4h4v4h4v4h4v12h4v8h-4v4h-4v4h4v4h8v4h4v60h-4v-4h-4v4h4v4h-4v32h-4v28h4v8h4v4h4v4h4v4h-8v4H28v-4h-8v-4h4v-8h4v-4h-4v-68h-4v4h-4v4h4v12h-4v4h4v12h-4v4h4v8h-4v-4h-4v-12h4v-4h-4v-12h4v-4h-4V72h4V60h4v-4h8v-4h12v-8h-4v-4h-4v-4h-4v-8h4v-4h4v-4h4v-4h-4v-4h8Zm-8 112h12v76H36v-12h-4v-32h4v-32Zm-12-8V80h-4v36h4Z"
          clipRule="evenodd"
        />
        <path d="M8 204v-4h8v4H8Z" />
      </g>
    </Icon>
  );
};

export const MonkeyIcon = ({ color, ...props }: IconProps) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4.5 24H3V21H4.5V24Z" fill="#B98359" />
      <path d="M4.5 21V19.5H7.5V21H4.5Z" fill="#B98359" />
      <path d="M13.5 16.5H12V19.5H13.5V16.5Z" fill="#B98359" />
      <rect x="12" y="15" width="1.5" height="1.5" fill="#2E1E06" />
      <path d="M13.5 3H12V4.5H13.5V6H15V7.5H16.5V9H18V7.5H16.5V6H15V4.5H13.5V3Z" fill="#64402E" />
      <path d="M19.5 13.5H18V15H15V16.5H18V15H19.5V13.5Z" fill="#64402E" />
      <path d="M16.5 10.5H15V12H16.5V10.5Z" fill="#C88D74" />
      <path d="M18 13.5H13.5V15H18V13.5Z" fill="#C88D74" />
      <path d="M13.5 10.5H12V12H13.5V10.5Z" fill="black" />
      <path d="M18 10.5H16.5V12H18V10.5Z" fill="black" />
      <path d="M10.5 9H7.5V12H9V10.5H10.5V9Z" fill="#AD7A65" />
      <path d="M16.5 7.5H15V9H13.5V13.5H19.5V12H15V10.5H18V9H16.5V7.5Z" fill="#E1AA90" />
      <path d="M10.5 10.5H9V12H10.5V10.5Z" fill="#E1AA90" />
      <path d="M13.5 7.5H12V10.5H13.5V7.5Z" fill="#C7967F" />
      <path d="M13.5 12H12V13.5H13.5V12Z" fill="#C7967F" />
      <path d="M10.5 3H12V4.5H10.5V3Z" fill="#4A2F22" />
      <path
        d="M13.5 6V4.5H12V6H10.5V7.5H9V9H10.5V12H9V13.5H10.5V15H13.5V18H16.5V16.5H15V15H13.5V13.5H12V7.5H13.5V9H15V6H13.5Z"
        fill="#4A2F22"
      />
      <path d="M12 18H10.5V19.5H12V21H13.5V22.5H16.5V21H18V19.5H16.5V21H13.5V19.5H12V18Z" fill="#CCD3E0" />
      <path d="M7.5 24H4.5V21H7.5V24Z" fill="#E6A46E" />
      <path d="M10.5 24H16.5V22.5H13.5V21H16.5V18H13.5V21H12V19.5H10.5V24Z" fill="#E6A46E" />
      <path d="M19.5 24V19.5H21V21H22.5V24H19.5Z" fill="#E6A46E" />
      <path d="M19.5 24V19.5H18V18H16.5V19.5H18V21H16.5V24H19.5Z" fill="#3D4543" />
      <path d="M10.5 24V18H9V24H10.5Z" fill="#3D4543" />
      <path d="M9 24H7.5V18H9V24Z" fill="#343434" />

      <g
        style={{
          mixBlendMode: "color",
        }}
      >
        <path
          d="M22.5 24H3V21H4.5V19.5H7.5V18H12V15H10.5V13.5H9V12H7.5V9H9V7.5H10.5V6H12V4.5H10.5V3H13.5V4.5H15V6H16.5V7.5H18V12H19.5V15H18V16.5H16.5V18H18V19.5H21V21H22.5V24Z"
          fill={color as string}
        />
      </g>
    </Icon>
  );
};
